import { render, staticRenderFns } from "./profile-view-authorizations-filters.vue?vue&type=template&id=f411c0bc&scoped=true&"
import script from "./profile-view-authorizations-filters.vue?vue&type=script&lang=js&"
export * from "./profile-view-authorizations-filters.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-authorizations-filters.vue?vue&type=style&index=0&id=f411c0bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f411c0bc",
  null
  
)

export default component.exports